<template>
  <div class="biz-control-bar">
    <i :class="playClass" @click="onPlay"></i>
    <span class="btn-forward" @mouseleave="showSpeedPanel = false">
          <div class="speed-handle"
               @mouseover="showSpeedPanel = true">{{speed}}x</div>
          <ul class="list-panel" v-show="showSpeedPanel">
            <li v-for="i in [4, 3, 2, 1, 0.5]"
                :key="'speed' + i"
                :class="{active: i === speed}"
                @click="onClickSpeed(i)">{{i}}x</li>
          </ul>
        </span>
    <div class="process-bar" @click="onClickProcess" ref="processBar">
      <div class="load-process" :style="'width:' + loadProcess + '%'"></div>
      <div class="process" :style="'width:' + processPercent + '%'"></div>
    </div>
    <span class="time-label">{{timeFormat(processTime)}} / {{timeFormat(duration)}}</span>
  </div>
</template>

<script>
import {util} from '../../utils'
export default {
  name: 'controlBar',
  props: {
    /**
     * 视屏时长
     */
    duration: {
      type: Number
    },
    /**
     * 页面是否加载完成
     */
    pageReady: {
      type: Boolean,
      default: false
    },
    loadProcess: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      showSpeedPanel: false,
      speed: 1,
      playing: false,
      // 播放时间轴中，上一个时间戳，用于计算时间过了多久
      preTimestamp: 0,
      // 已经播放的时间（毫秒值）
      processTime: 0,
      isOnline: window.navigator.onLine
    }
  },
  computed: {
    processPercent () {
      let percent = this.processTime / this.duration * 100
      return percent >= 100 ? 100 : percent
    },
    playClass () {
      let playAble = this.playing && this.pageReady
      return {
        'btn-play': true,
        'icon-start': !playAble,
        'icon-pause1': playAble
      }
    }
  },
  mounted () {
    window.addEventListener('offline', this.offline)
    window.addEventListener('online', this.online)
  },
  beforeDestroy () {
    window.removeEventListener('offline', this.offline)
    window.removeEventListener('online', this.online)
  },
  methods: {
    /**
     * @description 切换播放速度
     */
    onClickSpeed (speed) {
      this.speed = speed
      this.showSpeedPanel = false
    },
    /**
     *
     * @param time
     * @return {*|string}
     */
    timeFormat (time) {
      return util.timeFormat(time, time > 60 * 60 * 1000 ? 'hh:mm:ss' : 'mm:ss')
    },
    /**
     * 点击播放按钮
     */
    onPlay () {
      if (!this.isOnline) {
        this.offline()
        return
      }
      this.playing = !this.playing
      if (this.playing) {
        if (this.processPercent >= 100) { // 重新播放
          this.processTime = 0
          this.preTimestamp = 0
          this.$emit('replay')
        }
        window.requestAnimationFrame(this.timeLine)
      } else {
        this.preTimestamp = 0
      }
    },
    /**
     * 播放时间线
     * @param timestamp
     */
    timeLine (timestamp) {
      if (!this.playing) return
      if (!this.preTimestamp) this.preTimestamp = timestamp
      if (!this.isOnline) return
      // 处理倍速问题
      if (this.pageReady) { // 页面加载完成，才能进行有效的播放
        this.aliveCheck()
        this.processTime = Math.min(this.processTime + (timestamp - this.preTimestamp) * this.speed,
          this.duration)
        this.$emit('process', this.processTime)
      }
      this.preTimestamp = timestamp

      if (this.processPercent >= 100) {
        this.playing = false
      }
      if (this.playing) window.requestAnimationFrame(this.timeLine)
    },
    /**
     * @description 暂停播放
     */
    pause () {
      this.playing = false
      this.preTimestamp = 0
    },
    /**
     * @description 检测窗口是否已经失活（requestAnimationFrame因为窗口隐藏等操作而暂停）
     */
    aliveCheck () {
      clearTimeout(this.aliveTimer)
      this.aliveTimer = setTimeout(() => {
        if (this.pageReady) this.pause() // 活跃检测超时
      }, 1000)
    },
    online () {
      this.isOnline = true
    },
    offline () {
      this.$message({
        type: 'error',
        message: '断网了，先检查一下网络再尝试播放。'
      })
      this.isOnline = false
      this.pause()
    },
    onClickProcess (event) {
      this.pause()
      const rect = this.$refs.processBar.getBoundingClientRect()
      const percent = (event.clientX - rect.x) / rect.width
      const processTime = this.duration * percent
      this.processTime = processTime
      this.$emit('setProcess', processTime)
    },
    reset () {
      this.processTime = 0
      this.preTimestamp = 0
    }
  }
}
</script>

<style lang="sass">
@import "styles/controlBar"
</style>
